module.exports = __webpack_public_path__ + "img/product32_img02.01a289e3.png";